export const CLICK_AND_COLLECT = 'Click & Collect (John Lewis and Waitrose)';

export const BUY_CURRENCY_IN_STORE =
  'Buy currency at John Lewis';

export const ALL_TRAVEL_MONEY_STORES = 'All travel money stores';
